import { gql } from '@apollo/client';

const appraiserObservationReportFragment = gql`
  fragment AppraiserObservationReportFields on ObservationReport {
    Id
    EventId
    Result
    ObservedUser {
      Id
      FullName
      SystemRole {
        DisplayName
      }
    }
    ObserverUser {
      Id
      FullName
    }
    Event {
      Id
      EndDate
      OrgUnitNames
    }
    Document {
      Id
      FileName
    }
  }
`;

export default appraiserObservationReportFragment;
